"use client";

import { useState } from "react";
import { ShoppingCart, Check, Loader2 } from "lucide-react";
import { useCart } from "@/components/cart/CartProvider";
import { Button } from "@/components/ui/button";

interface AddToCartButtonProps {
  productId: string;
  variant?: "default" | "outline";
  size?: "default" | "sm" | "lg";
}

export function AddToCartButton({
  productId,
  variant = "default",
  size = "default",
}: AddToCartButtonProps) {
  const { addItem } = useCart();
  const [status, setStatus] = useState<"idle" | "adding" | "added">("idle");

  const handleClick = async () => {
    if (status === "adding") return;
    setStatus("adding");
    try {
      await addItem({ productId, quantity: 1 });
      setStatus("added");
      setTimeout(() => setStatus("idle"), 1500);
    } catch {
      setStatus("idle");
    }
  };

  return (
    <Button
      type="button"
      variant={variant}
      size={size}
      onClick={handleClick}
      disabled={status !== "idle"}
      aria-label="Add to cart"
    >
      {status === "added" ? (
        <>
          <Check className="mr-2 h-4 w-4" aria-hidden />
          Added
        </>
      ) : status === "adding" ? (
        <>
          <Loader2 className="mr-2 h-4 w-4 animate-spin" aria-hidden />
          Adding…
        </>
      ) : (
        <>
          <ShoppingCart className="mr-2 h-4 w-4" aria-hidden />
          Add to cart
        </>
      )}
    </Button>
  );
}
